import Vue from "vue";

const actions = {
    async getUserExternalNotifications(context, userId) {
        return await Vue.http.get(`/users/external_notifications/${userId}`).catch(err => err.response);
    },
    async saveUserExternalNotifications(context, request) {
        return await Vue.http.post(`/users/external_notifications/${request.userId}`, request.payload).catch(err => err.response);
    },
    async getUserInfo(context, userId) {
        return await Vue.http.get(`/users/${userId}`).catch(err => err.response);
    }
}

export default {
    actions
};


// WEBPACK FOOTER //
// ./src/store/modules/users/UserExternalNotifications.js